import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeUp from "@mui/icons-material/VolumeUp";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import React from "react";
const marks = [
    {
        value: 0,
        label: "0°C",
    },
    {
        value: 20,
        label: "20°C",
    },
    {
        value: 37,
        label: "37°C",
    },
    {
        value: 100,
        label: "100°C",
    },
];
function valuetext(value) {
    return `${value}°C`;
}
export default function SliderExample() {
    const [value, setValue] = React.useState(30);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (_jsxs(Box, Object.assign({ sx: { width: 300 } }, { children: [_jsx(Typography, Object.assign({ id: "continuous-slider", gutterBottom: true }, { children: "Volume" })), _jsxs(Grid, Object.assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, { children: _jsx(VolumeDown, {}) }), _jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Slider, { value: value, onChange: handleChange, "aria-labelledby": "continuous-slider" }) })), _jsx(Grid, { children: _jsx(VolumeUp, {}) })] })), _jsx(Typography, Object.assign({ id: "disabled-slider", gutterBottom: true }, { children: "Disabled slider" })), _jsx(Slider, { disabled: true, defaultValue: 30, "aria-labelledby": "disabled-slider" }), _jsx(Typography, Object.assign({ id: "discrete-slider-always", gutterBottom: true }, { children: "Always visible" })), _jsx(Slider, { defaultValue: 80, getAriaValueText: valuetext, "aria-labelledby": "discrete-slider-always", step: 10, marks: marks, valueLabelDisplay: "on" })] })));
}
